<script setup>
// Oct 22, 2026: colored bar on warehouse stations while an admin is "working as"
// another worker (see helpers/workingAs.js), so it can't be left on by accident.
// Shows nothing otherwise. Not shown on Warehouse Home (it has its own control)
// or the Tally Board (wall display).
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getWorkingAs, clearWorkingAs } from '@/helpers/workingAs.js'

const route = useRoute()
const router = useRouter()

const rawSession = () => {
  try {
    const s = localStorage.getItem('warehouseSession')
    return s ? JSON.parse(s) : null
  } catch {
    return null
  }
}

const state = ref(null)   // { name, me }
const HIDE_ON = ['/warehouse', '/warehouse/', '/warehouse/tally', '/warehouse/login', '/warehouse/logout']

watch(() => route.fullPath, () => {
  state.value = null
  if (!route.path.startsWith('/warehouse') || HIDE_ON.includes(route.path)) return
  const s = rawSession()
  const w = getWorkingAs(s)
  if (w) state.value = { name: w.workerName, me: s?.workerName || 'yourself' }
}, { immediate: true })

const show = computed(() => !!state.value)

function switchBack() {
  if (!window.confirm(`Switch back to logging as ${state.value.me}? This takes you to Warehouse Home.`)) return
  clearWorkingAs()
  state.value = null
  router.push('/warehouse')
}
</script>

<template>
  <div v-if="show" class="wa-bar">
    <span>Logging as <strong>{{ state.name }}</strong></span>
    <button type="button" @click="switchBack">Switch back</button>
  </div>
</template>

<style scoped>
.wa-bar {
  position: sticky;
  top: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 6px 12px;
  background: #f59e0b;
  color: #451a03;
  font-size: 14px;
}
.wa-bar button {
  background: #451a03;
  color: #fff;
  border: 0;
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 13px;
  cursor: pointer;
}
</style>
